import { useState } from "react";
import "../styles/Filters.css";
import Input from "./input";

const DateFilterDropdown = ({
  filterName = "dateRangeFilter",
  searchFilters,
  setSearchFilters,
  closeFilter,
  columnName = "Date",
  alignRight = false,
  setWrapperRef,
}) => {
  // Extract initial values from searchFilters
  const currentFilter = searchFilters?.[filterName];
  const initialStartDate = (
    currentFilter?.value?.startDate ||
    (typeof currentFilter?.value === "string" ? currentFilter?.value : "") ||
    ""
  ).split("T")[0];

  const initialEndDate = (
    currentFilter?.value?.endDate ||
    ""
  ).split("T")[0];

  const [fromDate, setFromDate] = useState(initialStartDate);
  const [toDate, setToDate] = useState(initialEndDate);

  // Both dates must be selected, OR both empty to clear
  const isOnlyOneSelected = Boolean((fromDate && !toDate) || (!fromDate && toDate));

  const handleApply = () => {
    // If both empty -> clear filter
    if ((!fromDate || !fromDate.trim()) && (!toDate || !toDate.trim())) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
      if (closeFilter) closeFilter();
      return;
    }

    // Both must be selected
    if (!fromDate || !fromDate.trim() || !toDate || !toDate.trim()) {
      return;
    }

    const cleanFrom = fromDate.trim().split("T")[0];
    const cleanTo = toDate.trim().split("T")[0];

    setSearchFilters((prev = {}) => ({
      ...prev,
      [filterName]: {
        filter_type: "date_range",
        value: {
          startDate: cleanFrom,
          endDate: cleanTo,
        },
      },
    }));

    if (closeFilter) closeFilter();
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
    >
      <div className="d-flex flex-column gap-2">
        <Input
          label="From Date"
          type="date"
          name="fromDate"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
        <Input
          label="To Date"
          type="date"
          name="toDate"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </div>

      <div className="filter_buttons mt-3">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button
          type="button"
          onClick={handleApply}
          className="btn-apply"
          disabled={isOnlyOneSelected}
          style={{ opacity: isOnlyOneSelected ? 0.5 : 1, cursor: isOnlyOneSelected ? "not-allowed" : "pointer" }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default DateFilterDropdown;
